import React from "react";
import { CompactMatchRow } from "./matchRowParts";

const pick_result_colour = (result) => {
  // Return backgroundColor for CSS-drawn circles
  if (result === "W") {
    return { backgroundColor: "#5da423" };
  } else if (result === "D") {
    return { backgroundColor: "#2ba6cb" };
  } else if (result === "L") {
    return { backgroundColor: "#c60f13" };
  } else {
    return { backgroundColor: "#d9d9d9" }; // neutral (matching JSP color)
  }
};

// A CSS-drawn circle per result.
const formIndicators = (results) =>
  results.map((result, i) => <span key={i} className="form-indicator" style={pick_result_colour(result)} />);

const SimpleMatchSummary = ({ item, pool_title }) => <CompactMatchRow item={item} pool_title={pool_title} formMarks={formIndicators} />;

export default SimpleMatchSummary;
